import { useMemo, useState } from 'react';
import type { FieldConfig, FieldPreset } from '@/components/TimesheetReports/FieldSelector';

/** Column visibility + saved presets for a report's FieldSelector. */
export function useReportColumns(defaultColumns: FieldConfig[]) {
  const [fieldConfigs, setFieldConfigs] = useState<FieldConfig[]>(defaultColumns);
  const [fieldPresets, setFieldPresets] = useState<FieldPreset[]>([]);
  const columnVisibility = useMemo(() => {
    const vis: Record<string, boolean> = {};
    fieldConfigs.forEach((f) => { vis[f.id] = f.visible; });
    return vis;
  }, [fieldConfigs]);

  return { fieldConfigs, setFieldConfigs, fieldPresets, setFieldPresets, columnVisibility };
}

export type ReportColumnsState = ReturnType<typeof useReportColumns>;
